<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLAnchorElement> {
		anchor: string;
		children: Snippet;
		active?: boolean;
	}

	let { anchor, children, active, ...other }: Props = $props();
</script>

<a
	data-subnavitem
	href="#{anchor}"
	class={[
		'whitespace-nowrap py-4 text-[16px] tracking-[-.16px] transition-[color] duration-300 ease-in-out lg:pb-6 lg:pt-7',
		{
			'text-brown-1': active,
			'text-brown-4 hover:text-brown-1': !active
		}
	]}
	{...other}
>
	{@render children()}
</a>
